import {useMutation} from "@apollo/client";
import { RetrieveArxivDataDocument } from "generated/graphql";

export const useRetrieveArxivData = () => useMutation(RetrieveArxivDataDocument);